import { Bar } from 'react-chartjs-2';
import React from 'react';
import ChartWrapper from '../../../../bidder/components/Charts/ChartWrapper';
import {
  downloadPNGByElementId,
  downloadCSVByDataset
} from '../../../../bidder/helpers/chart-helper';

import charts from '../../../../bidder/constants/colors/charts';

const getOptions = () => {
  return {
    plugins: {
      title: {
        display: false
      },
      legend: {
        display: false
      }
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false
        }
      }
    },
    maintainAspectRatio: false,
    responsive: true,
    maxHeight: 300
  };
};

export default function TotalByVendor({ data, stage, showDownload = true }) {
  const id = `${stage.toUpperCase()}-total-by-vendors`;
  const dataset = {
    labels: data.labels,
    datasets: [
      {
        label: 'Score',
        data: data.datasets,
        backgroundColor: charts[stage]
      }
    ]
  };

  const downloadCallbackAsImage = () => {
    downloadPNGByElementId(id, id);
  };

  const downloadCallbackAsCSV = () => {
    downloadCSVByDataset(id, dataset);
  };

  return (
    <>
      <ChartWrapper
        downloadCallbackAsImage={showDownload ? downloadCallbackAsImage : null}
        downloadCallbackAsCSV={showDownload ? downloadCallbackAsCSV : null}>
        <Bar id={id} height={300 + 'px'} options={getOptions()} data={dataset} />
      </ChartWrapper>
    </>
  );
}
